module.exports = __webpack_public_path__ + "static/media/section-blog-header.9bf0c499.png";